<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header">
          <div>
            <h4>Thêm mới yêu cầu công tác</h4>
          </div>
        </div>
        <div class="main-body mt-1">
          <div class="main-body-table">
            <div class="form-card mb-3">
              <el-card class="box-card">
                <div>
                  <el-form
                    :model="mData.dataForm"
                    :rules="mData.validForm"
                    ref="myForm"
                    label-width="160px"
                    label-position="top"
                  >
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          label="Tiêu đề"
                          prop="employee_request.title"
                        >
                          <el-input
                            type="text"
                            v-model="mData.dataForm.employee_request.title"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                            ref="title"
                          ></el-input>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          label="Phân loại"
                          prop="employee_request.type"
                        >
                          <el-select
                            disabled
                            clearable
                            filterable
                            v-model="mData.dataForm.employee_request.type"
                          >
                            <el-option
                              v-for="item in mData.dataDefault.listType"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12" v-if="mData.reselectEmployee">
                        <el-form-item
                          label="Nhân viên"
                          prop="employee_request.employee_id"
                        >
                          <el-select
                            filterable
                            v-model="
                              mData.dataForm.employee_request.employee_id
                            "
                            :disabled="!isSelectEmployee"
                            @change="fn_reselectEmployee"
                          >
                            <el-option
                              v-for="item in filteredRequestEmployees"
                              :key="item.id"
                              :label="fn_setLabelRespectively(item)"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1" v-if="mData.reselectEmployee">
                      <b-col md="6">
                        <el-form-item label="Chi nhánh">
                          <el-select
                            v-model="requestEmployeeFilter.branch_ids"
                            multiple
                            filterable
                            clearable
                            disabled
                            collapse-tags
                            placeholder="Tất cả chi nhánh"
                            @change="fn_resetEmployeeWhenFilteredOut"
                          >
                            <el-option
                              v-for="item in filteredBranchList"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                      <b-col md="6">
                        <el-form-item label="Phòng ban">
                          <el-select
                            v-model="requestEmployeeFilter.department_ids"
                            multiple
                            filterable
                            clearable
                            disabled
                            collapse-tags
                            placeholder="Tất cả phòng ban"
                            @change="fn_resetEmployeeWhenFilteredOut"
                          >
                            <el-option
                              v-for="item in filteredDepartmentList"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          label="Quản lý trực tiếp"
                          prop="employee_request.level2Approval"
                        >
                          <DirectManagerField
                            v-model="
                              mData.dataForm.employee_request.level2Approval
                            "
                            :options="mData.dataDefault.listQuanLyTrucTiep"
                            :label-builder="fn_setLabelRespectively"
                          />
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          label="Quản lý nhân sự"
                          prop="employee_request.employeeApproval"
                        >
                          <el-select
                            clearable
                            filterable
                            v-model="
                              mData.dataForm.employee_request.employeeApproval
                            "
                          >
                            <el-option
                              v-for="(item, index) in listHrApprove"
                              :key="item.e && item.e.id ? item.e.id : index"
                              :label="
                                item.e &&
                                item.e.administrative_info &&
                                item.e.administrative_info.name &&
                                item.e.administrative_info.name.full_name
                                  ?`${item.e.employee_no ? item.e.employee_no : ''} - ${item.e.administrative_info.name.full_name ? item.e.administrative_info.name.full_name : ''}`
                                  : 'không xác định'
                              "
                              :value="item.e && item.e.id ? item.e.id : ''"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          label="Lý do"
                          prop="detail_request.request_reason_id"
                        >
                          <el-select
                            clearable
                            filterable
                            v-model="
                              mData.dataForm.detail_request.request_reason_id
                            "
                          >
                            <el-option
                              v-for="item in mData.dataDefault
                                .listRequestReason"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="6">
                        <el-form-item
                          label="Thời gian từ"
                          prop="detail_request.start_date"
                        >
                          <el-date-picker
                            type="date"
                            v-model="mData.dataForm.detail_request.start_date"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                            prefix-icon="isax-calendar-1"
                            :clearable="false"
                            :format="'dd/MM/yyyy' || 'dd-MM-yyyy'"
                            :picker-options="pickerOptionFromGoOnBussiness"
                            @change="fn_checkValidDate"
                          ></el-date-picker>
                        </el-form-item>
                      </b-col>
                      <b-col md="6">
                        <el-form-item
                          label="tới"
                          prop="detail_request.end_date"
                        >
                          <el-date-picker
                            type="date"
                            v-model="mData.dataForm.detail_request.end_date"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                            prefix-icon="isax-calendar-1"
                            :clearable="false"
                            :format="'dd/MM/yyyy' || 'dd-MM-yyyy'"
                            :picker-options="pickerOptionFromGoOnBussiness"
                            @change="fn_checkValidDate"
                          ></el-date-picker>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          label="Ghi chú"
                          prop="employee_request.content"
                        >
                          <el-input
                            type="textarea"
                            v-model="mData.dataForm.employee_request.content"
                            :disabled="mData.viewMode == 'detail'"
                            resize="none"
                            :autosize="{ minRows: 3, maxRows: 3 }"
                          ></el-input>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <div class="text-center mt-2">
                      <el-button
                        v-if="mData.viewMode == 'create'"
                        class="btn-default"
                        @click="fn_submitForm('create')"
                        >Thêm mới</el-button
                      >
                      <el-button
                        v-if="mData.viewMode == 'create'"
                        class="btn-back"
                        @click="fn_goBack"
                        >Quay lại</el-button
                      >
                    </div>
                  </el-form>
                </div>
              </el-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MethodService from "../../../../service/MethodService";
import EmployeeRequestApi from "../../../../moduleApi/EmployeeRequestApi";
import EmployeeRequestGoOnBussinessApi from "../../../../moduleApi/EmployeeRequestGoOnBussinessApi";
import DirectManagerField from "../components/DirectManagerField";
import { dataMixins } from "../../ManageRequests/RequestMixins/dataMixins";
import { fnMixins } from "../../ManageRequests/RequestMixins/fnMixins";
export default {
  components: { DirectManagerField },
  mixins: [dataMixins, fnMixins],
  data() {
    return {
      typeReq: "GO_ON_BUSSINESS",
    };
  },
  computed: {
    filteredDepartmentList() {
      const employeeId = this.mData.dataForm.employee_request.employee_id;
      if (!employeeId) {
        return (this.mData.dataDefault.listDepartment || []).filter(
          (dept) => dept.company_id === this.currentCompany.id
        );
      }

      const selectedEmployee = this.fn_findRequestEmployeeById(employeeId);
      const departmentIds = [
        ...new Set(
          (this.fn_getActiveJobInfo(selectedEmployee) || [])
            .map((item) => item.department_id)
            .filter(Boolean)
        ),
      ];

      return (this.mData.dataDefault.listDepartment || []).filter((dept) =>
        departmentIds.includes(dept.id)
      );
    },
    filteredBranchList() {
      const employeeId = this.mData.dataForm.employee_request.employee_id;
      if (!employeeId) {
        return (this.mData.dataDefault.listBranch || []).filter(
          (branch) => branch.company_id === this.currentCompany.id
        );
      }

      const selectedEmployee = this.fn_findRequestEmployeeById(employeeId);
      const branchIds = [
        ...new Set(
          (this.fn_getActiveJobInfo(selectedEmployee) || [])
            .map((item) => item.branch_id)
            .filter(Boolean)
        ),
      ];

      return (this.mData.dataDefault.listBranch || []).filter((branch) =>
        branchIds.includes(branch.id)
      );
    },
  },

  methods: {
    async fn_innitDataDefault() {
      await this.fn_getListEmployee();
      await this.fn_getListEmployeeRequestReason(this.typeReq);
      await this.fn_getListEmployeeApprovedQLTT();
    },

    fn_syncRequestOrgFilterByEmployee(employeeId) {
      if (!employeeId) return;
      const selectedEmployee = this.fn_findRequestEmployeeById(employeeId);
      if (!selectedEmployee) return;

      const activeJobs = this.fn_getActiveJobInfo(selectedEmployee);
      this.requestEmployeeFilter.department_ids = [
        ...new Set(
          (activeJobs || [])
            .map((item) => item.department_id)
            .filter(Boolean)
        ),
      ];
      this.requestEmployeeFilter.branch_ids = [
        ...new Set(
          (activeJobs || [])
            .map((item) => item.branch_id)
            .filter(Boolean)
        ),
      ];

      this.$nextTick(() => {
        this.fn_resetEmployeeWhenFilteredOut();
      });
    },

    fn_checkValidDate() {
      const startTime = new Date(
        this.mData.dataForm.detail_request.start_date
      ).getTime();
      const endTime = new Date(
        this.mData.dataForm.detail_request.end_date
      ).getTime();
      if (startTime && endTime && startTime > endTime) {
        this.mData.dataForm.detail_request.end_date = undefined;
        window.toastr.warning(
          "Mốc 'tới' phải là lớn hơn hoặc bằng mốc 'Thời gian từ' !"
        );
      }
    },

    //Form
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          try {
            let listApprovalUser = [];
            listApprovalUser = [
              {
                approval_user_id:
                  this.mData.dataForm.employee_request.level2Approval,
              },
              {
                approval_user_id:
                  this.mData.dataForm.employee_request.employeeApproval,
              },
            ];
            this.mData.dataForm.employee_request.title =
              this.mData.dataForm.employee_request.title.trim();
            this.mData.dataForm.employee_request.content =
              this.mData.dataForm.employee_request.content.trim();
            this.mData.dataForm.employee_request.company_id =
              this.currentCompany.id;
            this.mData.dataForm.employee_request.approval_users =
              listApprovalUser;
            this.mData.dataForm.employee_request.is_sequential = true;
            this.mData.dataForm.employee_request.approval_level = 2;
            let dataEmployeeRequest = this.mData.dataForm.employee_request;
            let dataEmployeeRequestDetail = this.mData.dataForm.detail_request;
            if (type == "create") {
              const res = await EmployeeRequestApi.create(dataEmployeeRequest);
              dataEmployeeRequestDetail.id = res.result;
              await EmployeeRequestGoOnBussinessApi.create(
                dataEmployeeRequestDetail
              );
              if (
                this.mData.dataDefault.listFeature.includes("FT1001") ||
                this.mData.dataDefault.listFeature.includes("FT1002")
              ) {
                this.$router.push({
                  name: "Admin-ManageRequests-RequestsWaitingForApproval",
                });
              }
              this.fn_resetForm();
              this.fn_checkHasEmployeeQTLL();
            }
          } catch (error) {
            console.log("error", error);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    async fn_reselectEmployee() {
      this.fn_syncRequestOrgFilterByEmployee(
        this.mData.dataForm.employee_request.employee_id
      );
      await this.fn_getListEmployeeApprovedQLTT(this.mData.dataForm.employee_request.employee_id, false);
      await this.$refs["myForm"].fields.find((f) => f.prop == "employee_request.employee_id").clearValidate();
      await this.forceUpdateUI();
    }
  },

  async created() {
    this.mData.dataForm.employee_request.type = "GO_ON_BUSSINESS";
    await this.fn_innitDataDefault();
    await this.fn_checkHasEmployeeQTLL();
    this.fn_syncRequestOrgFilterByEmployee(
      this.mData.dataForm.employee_request.employee_id
    );
    await this.forceUpdateUI();
  },
  mounted() {
    this.$refs.title.focus();
  },
};
</script>
<style scoped src="../../../../assets/css/layout/Request.css">
</style>
